// The answers offered as a shortcut, and the one that carries a consequence.
//
// Both lists are proposals from the domain rather than from our data. The order
// is an estimate; a read of the existing free-text `position` and
// `reasonForLeaving` values should settle it before this reaches every company.
// "Other" is not only an escape hatch — it is the backlog of values to add.

/**
 * What a new employment entry starts as.
 *
 * The generic answer, and true of most entries. Worth knowing what this costs:
 * a prefilled title is no longer a deliberate statement, so "Truck Driver" in
 * the data now means "did not change it" as often as it means the job.
 */
export const DEFAULT_JOB_TITLE = 'Truck Driver'

/** Chips describe the run, not the trailer: equipment has its own field. */
export const JOB_TITLES = [
  'Truck Driver',
  'OTR Driver',
  'Regional Driver',
  'Local Driver',
  'Owner Operator',
] as const

export const REASONS_FOR_LEAVING = [
  'Better opportunity',
  'Higher pay',
  'Home time',
  'Company closed or downsized',
  'Laid off',
  'Terminated / discharged',
  'Personal or family reasons',
  'End of contract or lease',
] as const

/**
 * The only reason that answers a federal question. It has to stay an explicit
 * option: hidden inside "Other" it would be free text, and the termination
 * certification would go on being asked as though nobody had already said so.
 */
export const TERMINATED_REASON = 'Terminated / discharged'

export const COMPLIANCE_QUESTIONS = {
  isDriverTerminated: 'Were you terminated?',
  isDriverSubjectToFMCSRs:
    'Were you subject to the Federal Motor Carrier Safety Regulations (FMCSRs) while employed?',
  isJobDesignatedAsSafetySensitiveFunctionUnderDOT:
    'Was this job designated as a safety-sensitive function under 49 CFR Part 40?',
  shouldContactEmployer: 'May we contact this employer?',
} as const
